import React, { Component } from "react";
import { connect } from "react-redux";
import dynamic from "next/dynamic";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";
import IconGlyph from '@/bit/components/next13.components.icon-glyph';
import getDeviceKindDependsOnViewPort from "@gerenciatd/next13.utils.common.get-device-kind-depends-on-viewport";
import { actions as modalActions } from "@/bit/reducers/next13.reducers.modals-reducer";
import { actions as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";

class CPMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: null,
    };
  }

  setDevice = () => {
    this.setState({ device });
  };

  handleCpModal = () => {
    const device = getDeviceKindDependsOnViewPort();
    const { addModal, cp, municipios, municipio, setCpModalClosed } = this.props;
    const CPModal = dynamic(() => import("../../../modals/cp"));

    let modalProps = {
      contentPosition: "center--bottom",
      opacityLayoutColor: "blur",
      inSceneEffect: "fadeInBottom",
      contentInsideContainer: false,
      outSceneEffect: "fadeOutBottom",
      closeByClickingOutside: true,
      closeIdByClickingOutside: "closeAll",
      onCloseHandler: () => { setCpModalClosed(true) }
    };

    if (device !== "MOBILE") {
      modalProps = {
        ...modalProps,
        contentPosition: "right--top",
        opacityLayoutColor: "blur",
        inSceneEffect: "fadeInBottom",
        contentInsideContainer: true,
        outSceneEffect: "fadeOutBottom",
        closeByClickingOutside: true,
        closeIdByClickingOutside: "",
        createAnchor: false,
      };
    }
    setCpModalClosed(false)
    addModal({
      id: "cp",
      Element2Show: CPModal,
      modalProps,
      elementProps: {
        cp: cp,
        municipio: municipio,
        municipios: municipios,
      },
    });
  };

  render() {
    const { cp } = this.props;
    return (
      <>
        <CustomLink
          title={`Ofertas para ${!cp ? '...' : cp }`}
          ariaLabel={`Ofertas para ${!cp ? '...': cp }`}
          onClick={this.handleCpModal}
          taggingInfo={{
            componentName: "header",
            componentContent: "openCP",
            componentVariation: "all",
            componentPerso: "",
            componentProduct: "",
          }}
        >
          <div
            key={`Item-${"Ofertas"}`}
            className={`menu-item ${"Ubicacion"}`}
            data-cy="Header ubicacion"
          >
            <IconGlyph color="grey6" id="ubicacion-s" width={15} />
            <div className="text-gap">
              <Text
                text={`Ofertas para ${!cp ? "..." : cp}`}
                align="center"
                fontType="font-regular"
                size="caption02"
                color="grey6"
                display="block"
                border="none"
              />
            </div>
          </div>
        </CustomLink>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  cp: state.main.cp,
});

const mapDispatchToProps = (dispatch) => ({
  addModal: (data) => dispatch(modalActions.addModal(data)),
  setCpModalClosed: (flag) => dispatch(mainActions.setCpModalClosed(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(CPMenu);